import { memo, useCallback } from "react"
import {
  switchQueryPeriod,
  switchView,
  usePageContext,
} from "@/lib/context/page"
import { useCogsStore } from "../store"
import { PeriodTypeView } from "@/types"
import {
  HistoricalDataButton,
  ViewSwitcher,
} from "@/components/shared/views-buttons"

export const CogsViewSwitcher = memo(
  (props: { disableStoreViewUpdate?: boolean }) => {
    const { state, dispatch } = usePageContext()
    const { setView } = useCogsStore()

    const handleViewSwitch = useCallback(
      (view: PeriodTypeView) => {
        dispatch(switchView(view))
        if (!props.disableStoreViewUpdate) {
          setView(view)
        }
      },
      [dispatch, setView, props.disableStoreViewUpdate]
    )

    const toggleHistoricalData = useCallback(() => {
      dispatch(
        switchQueryPeriod(state.queryPeriod === `all` ? state.period : `all`)
      )
    }, [dispatch, state.queryPeriod, state.period])

    return (
      <div className="flex items-center gap-2">
        {state.period === `forecast` ? (
          <HistoricalDataButton
            showHistoricalData={state.queryPeriod === `all`}
            onClick={toggleHistoricalData}
          />
        ) : null}
        <ViewSwitcher view={state.view} onViewChange={handleViewSwitch} />
      </div>
    )
  }
)

CogsViewSwitcher.displayName = `CogsViewSwitcher`
